exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
};
exports.isValid = function (p18228) {
  return p18228 != null && p18228 !== "" && !isNaN(p18228) && p18228 >= 0 && p18228 <= 7;
};
exports.from = function (p18229) {
  if (exports.isValid(p18229)) {
    return parseInt(p18229, 10);
  } else {
    return undefined;
  }
};
exports.getPenaltyN1 = function (p18230) {
  const v14024 = p18230.size;
  let vLN02566 = 0;
  let vLN02567 = 0;
  let vLN02568 = 0;
  let v14025 = null;
  let v14026 = null;
  for (let vLN02569 = 0; vLN02569 < v14024; vLN02569++) {
    vLN02567 = vLN02568 = 0;
    v14025 = v14026 = null;
    for (let v14027, vLN02570 = 0; vLN02570 < v14024; vLN02570++) {
      v14027 = p18230.get(vLN02569, vLN02570);
      if (v14027 === v14025) {
        vLN02567++;
      } else {
        if (vLN02567 >= 5) {
          vLN02566 += 3 + (vLN02567 - 5);
        }
        v14025 = v14027;
        vLN02567 = 1;
      }
      v14027 = p18230.get(vLN02570, vLN02569);
      if (v14027 === v14026) {
        vLN02568++;
      } else {
        if (vLN02568 >= 5) {
          vLN02566 += 3 + (vLN02568 - 5);
        }
        v14026 = v14027;
        vLN02568 = 1;
      }
    }
    if (vLN02567 >= 5) {
      vLN02566 += 3 + (vLN02567 - 5);
    }
    if (vLN02568 >= 5) {
      vLN02566 += 3 + (vLN02568 - 5);
    }
  }
  return vLN02566;
};
exports.getPenaltyN2 = function (p18231) {
  const v14028 = p18231.size;
  let vLN02571 = 0;
  for (let vLN02572 = 0; vLN02572 < v14028 - 1; vLN02572++) {
    for (let vLN02573 = 0; vLN02573 < v14028 - 1; vLN02573++) {
      const v14029 = p18231.get(vLN02572, vLN02573) + p18231.get(vLN02572, vLN02573 + 1) + p18231.get(vLN02572 + 1, vLN02573) + p18231.get(vLN02572 + 1, vLN02573 + 1);
      if (v14029 === 4 || v14029 === 0) {
        vLN02571++;
      }
    }
  }
  return vLN02571 * 3;
};
exports.getPenaltyN3 = function (p18232) {
  const v14030 = p18232.size;
  let vLN02574 = 0;
  let vLN02575 = 0;
  let vLN02576 = 0;
  for (let vLN02577 = 0; vLN02577 < v14030; vLN02577++) {
    vLN02575 = vLN02576 = 0;
    for (let vLN02578 = 0; vLN02578 < v14030; vLN02578++) {
      vLN02575 = vLN02575 << 1 & 2047 | p18232.get(vLN02577, vLN02578);
      if (vLN02578 >= 10 && (vLN02575 === 1488 || vLN02575 === 93)) {
        vLN02574++;
      }
      vLN02576 = vLN02576 << 1 & 2047 | p18232.get(vLN02578, vLN02577);
      if (vLN02578 >= 10 && (vLN02576 === 1488 || vLN02576 === 93)) {
        vLN02574++;
      }
    }
  }
  return vLN02574 * 40;
};
exports.getPenaltyN4 = function (p18233) {
  let vLN02579 = 0;
  const v14031 = p18233.data.length;
  for (let vLN02580 = 0; vLN02580 < v14031; vLN02580++) {
    vLN02579 += p18233.data[vLN02580];
  }
  const v14032 = Math.abs(Math.ceil(vLN02579 * 100 / v14031 / 5) - 10);
  return v14032 * 10;
};
function f2171(p18234, p18235, p18236) {
  switch (p18234) {
    case exports.Patterns.PATTERN000:
      return (p18235 + p18236) % 2 == 0;
    case exports.Patterns.PATTERN001:
      return p18235 % 2 == 0;
    case exports.Patterns.PATTERN010:
      return p18236 % 3 == 0;
    case exports.Patterns.PATTERN011:
      return (p18235 + p18236) % 3 == 0;
    case exports.Patterns.PATTERN100:
      return (Math.floor(p18235 / 2) + Math.floor(p18236 / 3)) % 2 == 0;
    case exports.Patterns.PATTERN101:
      return p18235 * p18236 % 2 + p18235 * p18236 % 3 == 0;
    case exports.Patterns.PATTERN110:
      return (p18235 * p18236 % 2 + p18235 * p18236 % 3) % 2 == 0;
    case exports.Patterns.PATTERN111:
      return (p18235 * p18236 % 3 + (p18235 + p18236) % 2) % 2 == 0;
    default:
      throw new Error("bad maskPattern:" + p18234);
  }
}
exports.applyMask = function (p18237, p18238) {
  const v14033 = p18238.size;
  for (let vLN02581 = 0; vLN02581 < v14033; vLN02581++) {
    for (let vLN02582 = 0; vLN02582 < v14033; vLN02582++) {
      if (!p18238.isReserved(vLN02582, vLN02581)) {
        p18238.xor(vLN02582, vLN02581, f2171(p18237, vLN02582, vLN02581));
      }
    }
  }
};
exports.getBestMask = function (p18239, p18240) {
  const v14034 = Object.keys(exports.Patterns).length;
  let vLN02583 = 0;
  let vInfinity3 = Infinity;
  for (let vLN02584 = 0; vLN02584 < v14034; vLN02584++) {
    p18240(vLN02584);
    exports.applyMask(vLN02584, p18239);
    const v14035 = exports.getPenaltyN1(p18239) + exports.getPenaltyN2(p18239) + exports.getPenaltyN3(p18239) + exports.getPenaltyN4(p18239);
    exports.applyMask(vLN02584, p18239);
    if (v14035 < vInfinity3) {
      vInfinity3 = v14035;
      vLN02583 = vLN02584;
    }
  }
  return vLN02583;
};